import { HttpStatusCode } from 'axios';

export const HttpStatusText: { [key: string]: number } = {
  ERR_FR_TOO_MANY_REDIRECTS: HttpStatusCode.TooManyRequests,
  ERR_BAD_OPTION_VALUE: HttpStatusCode.BadRequest,
  ERR_BAD_OPTION: HttpStatusCode.BadRequest,
  ERR_NETWORK: HttpStatusCode.TooManyRequests,
  ERR_FAILED: HttpStatusCode.TooManyRequests,
  ERR_DEPRECATED: HttpStatusCode.BadRequest,
  ERR_BAD_RESPONSE: HttpStatusCode.BadRequest,
  ERR_BAD_REQUEST: HttpStatusCode.BadRequest,
  ERR_NOT_SUPPORT: HttpStatusCode.BadRequest,
  ERR_INVALID_URL: HttpStatusCode.BadRequest,
  ERR_CANCELED: HttpStatusCode.BadRequest,
  ECONNABORTED: HttpStatusCode.RequestTimeout,
  ETIMEDOUT: HttpStatusCode.RequestTimeout,
};

export const ErrorMessage: { [key: number]: string } = {
  0: 'Tivemos um problema ao efetuar seu login. Tente novamente.',
  401: 'Tivemos um problema ao efetuar seu login. Tente novamente ou contate nossa Central de Atendimento.',
  403: 'Tivemos um problema ao efetuar seu login. Tente novamente ou contate nossa Central de Atendimento.',
  404: 'Tivemos um problema ao efetuar seu login. Verifique sua conexão de internet e tente novamente.',
  429: 'Tivemos um problema ao efetuar seu login. Tente novamente.',
};
